import React, { createContext, useContext } from 'react';
import { Logger } from 'AppShell/appshell_types/loggerTypes';

const LoggerContext = createContext({} as Logger);
export const LoggerProvider = LoggerContext.Provider;
const { Consumer } = LoggerContext;

export interface LoggerConsumer {
    logger: Logger;
}

export const withLogger =
    <T extends Object>(Component: React.ComponentType<T & LoggerConsumer>): React.ComponentType<T> =>
    (props: T) =>
        (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <Consumer>{logger => <Component logger={logger} {...props} />}</Consumer>
        );

export const useLogger = (): Logger => useContext(LoggerContext);

export default withLogger;
